export default __webpack_public_path__ + "static/media/check.f306c526.png";